<template>
  <div class="d-inline-block">
    <div
      v-if="showPopover"
      ref="popper"
      class="popover"
    >
      <h3
        v-if="getTitle"
        class="popover-header"
      >
        {{ getTitle }}
      </h3>
      <div class="popover-body">
        <slot>{{ content }}</slot>
      </div>
    </div>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core';

export default {
  name: 'MPopover',
  props: {
    trigger: {
      type: String,
      default: 'click',
    },
    placement: {
      type: String,
      default: 'top',
    },
    title: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    showPopover: false,
    popperInstance: null,
  }),
  watch: {
    showPopover(val) {
      this.$nextTick(() => {
        if (val) {
          this.resetPopperInstance();
        }
      });
    },
  },
  computed: {
    getTriggerElement() {
      return this.target ? document.querySelector(`#${this.target}`) : null;
    },
    getTitle() {
      return this.title ? this.title : document.querySelector(`#${this.target}`).title;
    },
  },
  mounted() {
    if (this.getTriggerElement) {
      if (this.trigger === 'click') {
        this.getTriggerElement.addEventListener('click', this.handleClick);
      } else {
        this.getTriggerElement.addEventListener('mouseenter', this.activatePopover);
        this.getTriggerElement.addEventListener('mouseleave', this.hidePopover);
      }
    }
  },
  beforeDestroy() {
    if (this.getTriggerElement) {
      if (this.trigger === 'click') {
        this.getTriggerElement.removeEventListener('click', this.handleClick);
      } else {
        this.getTriggerElement.removeEventListener('mouseenter', this.activatePopover);
        this.getTriggerElement.removeEventListener('mouseleave', this.hidePopover);
      }
    }
  },
  methods: {
    handleClick(e) {
      this.showPopover = !this.showPopover;
    },
    activatePopover() {
      this.showPopover = true;
    },
    hidePopover(e) {
      this.showPopover = false;
    },
    resetPopperInstance() {
      if (this.popperInstance) {
        this.popperInstance.destroy();
        this.popperInstance = null;
      }
      const popoverDistance = 8;
      this.popperInstance = createPopper(this.getTriggerElement, this.$refs.popper, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, popoverDistance],
            },
          },
        ],
      });
    },
  },
};
</script>
